import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { API, fileUpload } from "../../../config";
import Spin from "../../../components/Spin";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import { formatSubcontractorName } from "../../../lib/Misc";
import UserSelect from "../../../components/UserSelect";
import { Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { EscalatedSchema } from "../../../lib/Validation";
import { Textarea } from "../../../components/ui/textarea";

const EscalatedModal = ({
  data,
  toggleConfirmEscalated,
  fetchData,
  setFieldValue,
}) => {
  const { organizationData } = useOrganization();
  const [loading, setLoading] = useState(false);

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append(`compliance_manager_id`, value.compliance_manager_id ?? "");
    formData.append(`reason`, value.reason ?? "");

    formData.append("_method", "put");
    try {
      setLoading(true);
      const response = await fileUpload(
        `${API.GET_CDD_RISK}${data?.id ? `/${data?.id}` : ""}`,
        formData,
      );
      setLoading(false);
      if (response?.data) {
        toggleConfirmEscalated();
        fetchData && fetchData();
        if (setFieldValue) {
          setFieldValue(
            "compliance_manager_name",
            value?.compliance_manager_id
              ? userListing?.find(
                  (item) => item.value === value?.compliance_manager_id,
                )?.label
              : "",
          );
          setFieldValue(
            "compliance_manager_id",
            value.compliance_manager_id ?? "",
          );
          setFieldValue("reason", value.reason ?? "");
        }
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{
        id: data?.id ? data?.id : "",
        compliance_manager_id: data?.compliance_manager_id
          ? data?.compliance_manager_id
          : "",
        reason: data?.reason ? data?.reason : "",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={EscalatedSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-hidden overflow-y-auto max-h-[80vh] p-6 border rounded-lg">
              <div className="grid lg:grid-cols-1 grid-cols-1 gap-4">
                {/* Verified By */}

                <div className="min-w-0">
                  <Label htmlFor="compliance_manager_id">
                    <CustomLabelText
                      labelText="Escalated To"
                      errorField={errors?.compliance_manager_id}
                      required={true}
                      bottomAlign={true}
                    />
                  </Label>
                  <div className="relative mt-2">
                    <UserSelect
                      orgId={organizationData?.organizationId}
                      frameworkData={userListing} // List of vendors
                      optionType="User"
                      handleSelect={(e) => {
                        setFieldValue(`compliance_manager_id`, e);
                      }}
                      name="compliance_manager_id"
                      disabled={false}
                      initialValue={
                        values?.compliance_manager_id
                          ? values?.compliance_manager_id
                          : ""
                      }
                      authUser={true}
                      compliance={true}
                      senior_manager={true}
                      setUserList={setUserList}
                      setUserLoading={setUserLoading}
                      onClear={() => {
                        setFieldValue(`compliance_manager_id`, "");
                      }}
                      className={
                        errors?.compliance_manager_id &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                      loading={userLoading}
                    />
                    {userLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>

                {/* Reason */}
                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="reason">
                    <CustomLabelText
                      labelText="Reason"
                      required={false}
                      errorField={errors?.reason}
                    />
                  </Label>
                  <Textarea
                    name="reason"
                    rows={4}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.reason}
                    disabled={data?.kyc?.status ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleConfirmEscalated();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default EscalatedModal;
